import { render, staticRenderFns } from "./refactor.vue?vue&type=template&id=153e51ce&"
import script from "./refactor.vue?vue&type=script&lang=js&"
export * from "./refactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports